import React, { useEffect, useState } from "react";
import LoadingStatus from "../../Components/PolicyStatusComponents/LoadingStatus";
import SuccesStatus from "../../Components/PolicyStatusComponents/SuccesStatus";
import Axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CircularProgress, colors } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import { red } from "@mui/material/colors";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { setLocalData } from "../../Utilities/Common/source";
import PaymentRedirectForm from "../../AgentAuthentication/HdfcErgoKYC/Utilities/PaymentRedirectForm";
import axiosInstance from "../../Utilities/djangoAxiosInstance";

const HdfcErgoPaymentStatus = () => {
  const [transactionData] = useSearchParams();
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const MerchantID = transactionData?.get("MerchantID");
  const TransactionNo = transactionData?.get("TransactionNo");
  const TransctionRefNo = transactionData?.get("TransctionRefNo");
  const BankReferenceNo = transactionData?.get("BankReferenceNo");
  const TxnAmount = transactionData?.get("TxnAmount");
  const BankCode = transactionData?.get("BankCode");
  const IsSIOpted = transactionData?.get("IsSIOpted");
  const PaymentMode = transactionData?.get("PaymentMode");
  const PG_Remarks = transactionData?.get("PG_Remarks");
  const PaymentStatus = transactionData?.get("PaymentStatus");
  const TransactionDate = transactionData?.get("TransactionDate");
  const decryptedProductRef = transactionData?.get("productRef");
  const decryptedResponseId = transactionData?.get("responseID");
  const pay_person = transactionData?.get("payPerson");
  const productName = transactionData?.get("productName");
  const policyStatus = transactionData?.get("policyStatus");
  const source = transactionData?.get("source");
  const [paymentError, setPaymentError] = useState(false);
  console.log("payment status source: ", source);
  setLocalData("source", source);
  console.log("product name", productName);
  const isNext = PaymentStatus !== "Successful Transaction";
  transactionData.forEach((ele) => console.log(ele));

  if (PaymentStatus !== "Successful Transaction") {
    Swal.fire({
      icon: "error",
      // title: `${response.data.data.iskycVerified}`,
      title: "Your Transaction has Failed",
      // footer: `<a href="${response.data.fetch.data.redirect_link}?redirectUrl=${response.data.r_url}">Please Click on This Link to complete your KYC`,
      position: "center",

      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
    });
  }

  function printDocument() {
    const input = document.getElementById("root");
    // HTMLCanvasElement()
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(imgData, "JPEG", 10, 10, 180, 150);
      // pdf.output('dataurlnewwindow');
      pdf.save("payment_details.pdf");
    });
  }

  const goBack = () => {
    navigate(-1);
  };

  const nextHandler = () => {
    // console.log('states',CKYC,EKYC)
    let path = "";
    let encryptedProduct_ref = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedProductRef),
        "secret key @123"
      ).toString()
    );
    let encryptedDataId = encodeURIComponent(
      CryptoJS.AES.encrypt(
        JSON.stringify(decryptedResponseId),
        "secret key @124"
      ).toString()
    );

    if (PaymentStatus !== "Successful Transaction") {
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "it.acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }
      axiosInstance.post(
        `api/hdfc-payment/${decryptedProductRef}/${decryptedResponseId}/null/`,
        {
          pay_person: source === "b2c" ? "b2cCustomer" : "posp",
        },
        {
          params: {
            source: source,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            console.log("Get Checksum", response.data);
            const Checksum = response.data;
            let pay_path =
              "/health-insurance/product-stastus/" + decryptedResponseId;
            if (pay_person === "customer") {
              pay_path = "/payment/" + decryptedResponseId + "?aid=";
            }
            navigate(pay_path, {
              state: {
                checksum: Checksum,
                refid: decryptedProductRef,
                resid: decryptedResponseId,
              },
            });
            // PaymentRedirectForm(Checksum);
          }
        })
        .catch((e) => {
          alert(e);
          setPaymentError(true)
        });
    } else if (
      PaymentStatus === "Successful Transaction" &&
      pay_person !== "customer"
    ) {
      if (
        productName.includes("Optima Restore") ||
        productName.includes("Optima Secure - Individual") ||
        productName.includes("Optima Secure - Family") ||
        productName.includes("Optima Super Secure - Individual") ||
        productName.includes("Optima Super Secure - Family") ||
        productName.includes("OptimaSecureGlobal - Family") ||
        productName.includes("OptimaSecureGlobal - Individual") ||
        productName.includes("OptimaSecureGlobalPlus - Family") ||
        productName.includes("OptimaSecureGlobalPlus - Individual")
      ) {
        nextHandlerForOptimaRestore();
      } else {
        path = `/health-insurance/product/${encryptedProduct_ref}*${encryptedDataId}`;
        navigate(path);
      }
    } else if (pay_person === "customer") {
      //   //   Axios.post(
      //   //     `${domain}/api/hdfc-payment/${decryptedProductRef}/${decryptedResponseId}/null/`
      //   //   )
      //   //   .then((response) => {
      //   //     if (response.status === 200) {
      //   //       console.log("Get Checksum", response.data);
      //   //       const Checksum = response.data;
      //         let pay_path = '/health-insurance/product-stastus/'+ decryptedResponseId
      //         if(pay_person=== "customer"){
      //           pay_path = "/payment/"+decryptedResponseId+"?aid="
      //         }
      //         navigate(pay_path,
      //         //    {
      //         //   state: {
      //         //     checksum: Checksum,
      //         //     refid: decryptedProductRef,
      //         //     resid: decryptedResponseId,
      //         //   },
      //         // }
      //         );
      //     //     // PaymentRedirectForm(Checksum);
      //     //   }
      //     // })
      //     // .catch((e) => {
      //     //   alert(e);
      //     // });
      //   }
      //  else if(PaymentStatus==="Successful Transaction" && pay_person === 'customer'){

      printDocument();
    }
  };

  const nextHandlerForOptimaRestore = async () => {
    let domain = "";
     
    console.log("domain", domain);
    console.log("decryptedResponseId", decryptedResponseId);

    setLoading(true);
    axiosInstance.post(
      `api/hdfc/submit-payment/${decryptedResponseId}/?source=${source}`
    )
      .then((response) => {
        console.log(
          "submit payment details optima restore response",
          response.data
        );
        if (response.data.details) {
          console.log("if part", response.data);
          alert(response.data.details + "\n" + response.data.message);
          setLoading(false);
        } else {
          // console.log('else part', response)
          if (response.data.message) {
            /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
            alert(response.data.message);
            //resetForm(formData= initialValues)
            setLoading(false);
          } else {
            console.log("imp response", response);
            console.log("imp id", response.data.id);

            navigate(
              `/health-insurance/hdfc-ergo-product-status/${response.data.id}`
            );
          }
        }
      })
      .catch((errors) => {
        console.log(
          "error submit payment details optima restore response",
          errors.response
        );
        setLoading(false);
        setPaymentError(true)
        // alert(errors.response.statusText)
        //resetForm(formData = initialValues);
      });
  };

  useEffect(() => {
    nextHandler();
  }, []);

  return (
    <div>
      <div className="header-section">
        <p className="insurence-title-sec">
          Health Insurance
          <KeyboardArrowDownIcon />
        </p>
      </div>
      <Container
        style={{ marginTop: 10, marginBottom: 10 }}
        maxWidth="sm md lg"
      >
        <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Typography>MerchantID:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>
                  <strong>{MerchantID}</strong>
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>TransactionNo:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>
                  <strong>{TransactionNo}</strong>
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>TransctionRefNo:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{TransctionRefNo} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>BankReferenceNo:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{BankReferenceNo} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>TxnAmount:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{TxnAmount} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>BankCode:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{BankCode} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>IsSIOpted:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{IsSIOpted} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>PaymentMode:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{PaymentMode} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>PG_Remarks:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{PG_Remarks} </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>
                  <strong>PaymentStatus:</strong>
                </Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography
                  sx={
                    isNext
                      ? { color: "warning.main" }
                      : { color: "success.main" }
                  }
                >
                  <strong> {PaymentStatus} </strong>
                </Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>TransactionDate:</Typography>
              </Grid>
              <Grid item xs={7}>
                <Typography>{TransactionDate} </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>

      <div className=" btn-sec  position-fixed bottom-0 ">
        {loading ? (
          <div className="mx-auto">
            <CircularProgress
              size={48}
              sx={{
                color: "red",
              }}
            />
          </div>
        ) : (
          <>
            <button className="reset-btn text-capitalize z-20" onClick={goBack}>
              Go Back
            </button>
          
                  <div className=" fixed top-0 left-0  ">
                    <div className="w-screen h-screen flex justify-center">
                      <div className="flex flex-col justify-center ">
                        <div className="flex flex-col justify-center bg-slate-50 p-4 opacity-75 rounded-sm shadow-sm">
                        {!paymentError ? (<><div className="text-2xl font-bold p-2 m-2">
                            Processing Payment
                          </div>
                          <div className="mx-auto">
                            <CircularProgress
                              size={48}
                              sx={{
                                color: "red",
                              }}
                            />
                          </div></>): <div className="text-2xl font-bold p-2 m-2 text-red-600">Something went wrong ...</div>}
                        </div>
                      </div>
                    </div>
                  </div>
      
          {(isNext || pay_person==="customer")&& <button
              className="submitBtn text-capitalize "
              onClick={nextHandler}
              // disabled={isNext}
            >
              {isNext
                ? "Pay Again"
                : pay_person === "customer"
                ? "Download Details"
                : null}
            </button> }
          </>
        )}
      </div>
    </div>
  );
};

export default HdfcErgoPaymentStatus;
